<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
  >
    <path
      d="M17.4309 3.85327L17.4329 11.9216C17.4328 16.8367 13.6532 20.8113 9.01489 20.8113C4.37809 20.8112 0.617496 16.8382 0.617432 11.9216V3.85522L9.04517 1.01733L17.4309 3.85327Z"
      fill="#59FFD7"
      stroke="#59FFD7"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2LogosInsuranceNav'
})
</script>
